module.exports = __webpack_public_path__ + "fonts/VWHeadWeb-Light.89cbc2ce.woff";